import { STATES } from "../../../../constants/states";

export const RELATIONSHIP_TO_INSURED_OPTIONS = [
  { display: "Self", value: "self" },
  { display: "Spouse", value: "spouse" },
  { display: "Child", value: "child" },
  { display: "Other", value: "other" },
];

// elementType = segment/actionSegment are just a fancy names given to the form section divider mentioned in formSchema config
// this is just to allow array iterator to differentiate b/w a form field and some other stuff
// like sub form heading or a subform heading along with some action control btn.
export const INITIAL_VALUES = {
  address: {
    city: "",
    state: "",
    street: "",
    zip_code: "",
  },
  child_sms_consent: false,
  consent: [],
  default_child_practice_autofill: false,
  dob: "",
  email: "",
  email_validation: "",
  emergency_contact_no: "",
  emergency_name: "",
  first_name: "",
  gender: "",
  insurance: [
    {
      form: {
        card_back: "",
        card_front: "",
        carrier: "",
        group_id: "",
        member_id: "",
        policy_holder_name: "",
        policy_holder_question: "yes",
        state: "",
      },
      type: "primary_insurance",
    },
  ],
  is_spmi: false,
  last_name: "",
  medication_management_services: null,
  mobile: "",
  pcp_id: "",
};

export const INITIAL_VALUES_V2 = {
  address: {
    city: "",
    state: "",
    street: "",
    zip_code: "",
  },
  child_sms_consent: false,
  consent: [],
  default_child_practice_autofill: false,
  dob: "",
  email: "",
  email_validation: "",
  emergency_contact_no: "",
  emergency_name: "",
  first_name: "",
  gender: "",
  insurance: {
    card_back: "",
    card_front: "",
    carrier: "",
    group_id: "",
    member_id: "",
    policy_holder_name: "",
    policy_holder_question: "yes",
    policy_relationship: "",
    state: "",
  },
  is_spmi: false,
  last_name: "",
  medication_management_services: null,
  mobile: "",
  pcp_id: "",
};

export const BASIC_SCHEMA = [
  {
    elementConfig: {
      label: "First Name",
      placeholder: "First name",
      type: "text",
    },
    elementType: "input",
    name: "first_name",
  },
  {
    elementConfig: {
      label: "Last Name",
      placeholder: "Last name",
      type: "text",
    },
    elementType: "input",
    name: "last_name",
  },
  {
    elementConfig: {
      label: "Date of Birth",
      placeholder: "MM/DD/YYYY",
      type: "text",
    },
    elementType: "input",
    name: "dob",
  },
  {
    elementConfig: {
      label: "Gender",
      options: [
        { display: "Male", value: "male" },
        { display: "Female", value: "female" },
      ],
      placeholder: "Gender",
    },
    elementType: "select",
    name: "gender",
  },
  {
    elementConfig: {
      label: "Mobile",
      placeholder: "Mobile",
      type: "text",
    },
    elementType: "input",
    name: "mobile",
  },
  {
    elementConfig: {
      label: "Email",
      placeholder: "Email",
      type: "email",
    },
    elementType: "input",
    name: "email",
  },
  {
    elementConfig: {
      label: "Re-Enter Email",
      placeholder: "Email",
      type: "email",
    },
    elementType: "input",
    name: "email_validation",
  },
  // below object does not render form element
  // only marks the hook for nested form and displays heading
  {
    displayName: "Address",
    elementType: "segment",
  },
  {
    elementConfig: {
      label: "Street",
      placeholder: "Enter Street",
      type: "text",
    },
    elementType: "input",
    name: "address.street",
  },
  {
    elementConfig: {
      label: "City",
      placeholder: "Enter City",
      type: "text",
    },
    elementType: "input",
    name: "address.city",
  },
  {
    elementConfig: {
      label: "State",
      options: STATES,
      placeholder: "Enter State",
    },
    elementType: "select",
    name: "address.state",
  },
  {
    elementConfig: {
      label: "Zip",
      placeholder: "Enter zip",
      type: "text",
    },
    elementType: "input",
    name: "address.zip_code",
  },
  {
    elementConfig: {
      label: "Emergency Contact Person",
      placeholder: "Emergency Contact Person",
      type: "text",
    },
    elementType: "input",
    name: "emergency_name",
  },
  {
    elementConfig: {
      label: "Emergency Contact Number",
      placeholder: "Emergency Contact Number",
      type: "text",
    },
    elementType: "input",
    name: "emergency_contact_no",
  },
];

export const PATIENT_BASIC_SCHEMA = [
  {
    elementConfig: {
      label: "First Name",
      placeholder: "First name",
      type: "text",
    },
    elementType: "readOnly",
    name: "first_name",
  },
  {
    elementConfig: {
      label: "Last Name",
      placeholder: "Last name",
      type: "text",
    },
    elementType: "readOnly",
    name: "last_name",
  },
  {
    elementConfig: {
      label: "Date of Birth",
      placeholder: "MM/DD/YYYY",
      type: "text",
    },
    elementType: "readOnly",
    name: "dob",
  },
  {
    elementConfig: {
      label: "Gender",
      options: [
        { display: "Male", value: "male" },
        { display: "Female", value: "female" },
      ],
      placeholder: "Gender",
    },
    elementType: "select",
    name: "gender",
  },
  {
    elementConfig: {
      label: "Mobile",
      placeholder: "Mobile",
      type: "text",
    },
    elementType: "input",
    name: "mobile",
  },
  {
    elementConfig: {
      label: "Email",
      placeholder: "Email",
      type: "email",
    },
    elementType: "input",
    name: "email",
  },
  {
    elementConfig: {
      label: "Re-Enter Email",
      placeholder: "Email",
      type: "email",
    },
    elementType: "input",
    name: "email_validation",
  },
  // below object does not render form element
  // only marks the hook for nested form and displays heading
  {
    displayName: "Address",
    elementType: "segment",
  },
  {
    elementConfig: {
      label: "Street",
      placeholder: "Enter Street",
      type: "text",
    },
    elementType: "input",
    name: "address.street",
  },
  {
    elementConfig: {
      label: "City",
      placeholder: "Enter City",
      type: "text",
    },
    elementType: "input",
    name: "address.city",
  },
  {
    elementConfig: {
      label: "State",
      options: STATES,
      placeholder: "Enter State",
    },
    elementType: "select",
    name: "address.state",
  },
  {
    elementConfig: {
      label: "Zip",
      placeholder: "Enter zip",
      type: "text",
    },
    elementType: "input",
    name: "address.zip_code",
  },
  {
    elementConfig: {
      label: "Emergency Contact Person",
      placeholder: "Emergency Contact Person",
      type: "text",
    },
    elementType: "input",
    name: "emergency_name",
  },
  {
    elementConfig: {
      label: "Emergency Contact Number",
      placeholder: "Emergency Contact Number",
      type: "text",
    },
    elementType: "input",
    name: "emergency_contact_no",
  },
];

export const PRI_INSURANCE_SCHEMA = [
  // below object does not render form element
  // only marks the hook for nested form and displays heading
  {
    displayName: "Primary Insurance Information",
    elementType: "segment",
  },
  {
    elementConfig: {
      label: "State",
      options: [],
      placeholder: "Select State",
    },
    elementType: "select",
    name: "insurance[0].form.state",
  },
  {
    elementConfig: {
      label: "Carrier",
      options: [],
      placeholder: "Select Carrier",
      sentenceCase: false,
    },
    elementType: "select",
    name: "insurance[0].form.carrier",
  },
  {
    elementType: "InsuranceCardBtn",
    type: "pri",
  },
  // {
  //     name: 'insurance[0].form.card_front',
  //     elementType: 'select',
  //     elementConfig: {
  //         options: [{ value: 'one', display: 'One' },
  //         { value: 'two', display: 'Two' },
  //         ],
  //         label: 'Plan type',
  //         placeholder: 'Select Plan type'
  //     }
  // },
  {
    elementConfig: {
      label: "Member ID",
      placeholder: "Enter Member ID",
      type: "text",
    },
    elementType: "input",
    name: "insurance[0].form.member_id",
  },
  {
    elementConfig: {
      label: "Policy Holder Name",
      placeholder: "Enter Policy Holder Name",
      type: "text",
    },
    elementType: "input",
    name: "insurance[0].form.policy_holder_name",
  },
  {
    elementConfig: {
      label: "Relationship to Insured",
      options: RELATIONSHIP_TO_INSURED_OPTIONS,
      placeholder: "Select Relationship",
    },
    elementType: "select",
    name: "insurance[0].form.policy_relationship",
  },
  {
    elementConfig: {
      label: "Policy Holder Date of Birth",
      placeholder: "MM/DD/YYYY",
      type: "text",
    },
    elementType: "input",
    name: "insurance[0].form.policy_dob",
  },
];

export const PRI_INSURANCE_SCHEMA_V2 = [
  // below object does not render form element
  // only marks the hook for nested form and displays heading
  {
    displayName: "Primary Insurance Information",
    elementType: "segment",
  },
  {
    elementConfig: {
      label: "State",
      options: [],
      placeholder: "Select State",
    },
    elementType: "select",
    name: "insurance.state",
  },
  {
    elementConfig: {
      label: "Carrier",
      options: [],
      placeholder: "Select Carrier",
      sentenceCase: false,
    },
    elementType: "select",
    name: "insurance.carrier",
  },
  {
    elementConfig: {
      label: "Member ID",
      placeholder: "Enter Member ID",
      type: "text",
    },
    elementType: "input",
    name: "insurance.member_id",
  },
  {
    elementConfig: {
      label: "Policy Holder Name",
      placeholder: "Enter Policy Holder Name",
      type: "text",
    },
    elementType: "input",
    name: "insurance.policy_holder_name",
  },
  {
    elementConfig: {
      label: "Relationship to Insured",
      options: RELATIONSHIP_TO_INSURED_OPTIONS,
      placeholder: "Select Relationship",
    },
    elementType: "select",
    name: "insurance.policy_relationship",
  },
  {
    elementConfig: {
      label: "Policy Holder Date of Birth",
      placeholder: "MM/DD/YYYY",
      type: "text",
    },
    elementType: "input",
    name: "insurance.policy_dob",
  },
];

export const SEC_INSURANCE_SCHEMA = [
  // below object does not render form element
  // only marks the hook for nested form and displays heading
  {
    action: {
      handler: (cb) => {
        cb();
      },
      name: "Remove",
      style: "Btn Btn--clr-err p-0",
    },
    displayName: "Secondary Insurance Information",
    elementType: "actionSegment",
  },
  {
    elementConfig: {
      label: "State",
      options: [],
      placeholder: "Select State",
    },
    elementType: "select",
    name: "insurance[1].form.state",
  },
  {
    elementConfig: {
      label: "Carrier",
      options: [],
      placeholder: "Select Carrier",
      sentenceCase: false,
    },
    elementType: "select",
    name: "insurance[1].form.carrier",
  },
  {
    elementType: "InsuranceCardBtn",
    type: "sec",
  },
  // {
  //     name: 'insurance[1].form.plan_type',
  //     elementType: 'select',
  //     elementConfig: {
  //         options: [{ value: 'one', display: 'One' },
  //         { value: 'two', display: 'Two' },
  //         ],
  //         label: 'Plan type',
  //         placeholder: 'Enter Plan type'
  //     }
  // },
  {
    elementConfig: {
      label: "Member Id",
      placeholder: "Enter Member Id",
      type: "text",
    },
    elementType: "input",
    name: "insurance[1].form.member_id",
  },
  {
    elementConfig: {
      label: "Policy Holder Name",
      placeholder: "Enter Policy Holder Name",
      type: "text",
    },
    elementType: "input",
    name: "insurance[1].form.policy_holder_name",
  },
  {
    elementConfig: {
      label: "Relationship to Insured",
      options: RELATIONSHIP_TO_INSURED_OPTIONS,
      placeholder: "Select Relationship",
    },
    elementType: "select",
    name: "insurance[1].form.policy_relationship",
  },
  {
    elementConfig: {
      label: "Policy Holder Date of Birth",
      placeholder: "MM/DD/YYYY",
      type: "text",
    },
    elementType: "input",
    name: "insurance[1].form.policy_dob",
  },
];

export const PATIENT_PCP_SCHEMA = [
  // below object does not render form element
  // only marks the hook for nested form and displays heading
  {
    displayName: "Primary Care Physician Information",
    elementType: "segment",
  },
  {
    elementConfig: {
      label: "Physician",
      options: [],
      placeholder: "Select Physician",
    },
    elementType: "select",
    name: "pcp_id",
  },
];

export const MED_MGMT_OPTIONS = {
  medication_management: {
    label: "Medication Consult Requested",
    order: 1,
  },
};
